module.exports = __webpack_public_path__ + "static/kamadan-8429a1fd14854e389ca58c03e3e43447.png";